import { TFunction } from 'i18next';

export enum LocatorType {
  Street = 'street',
  City = 'city',
  RealEstate = 'realEstate',
  address = 'address',
  Other = 'other'
}

export const LocatorTypeOptions = (t: TFunction) =>
  [LocatorType.Street, LocatorType.City, LocatorType.RealEstate, LocatorType.address, LocatorType.Other].map(
    (code) => ({
      code: code,
      description: t(`locator${code.charAt(0).toUpperCase() + code.slice(1)}`)
    })
  );
